var alignmentStyle = {"alignLeft":"eim0N","textWrapNowrap":"SkYDu","alignRight":"U-0RY","alignCenter":"HRFzO","sizeFullWidth":"RXoS-","renderedInTable":"eZW1F","sizeOriginal":"kIb5H","sizeContent":"SjxSn","sizeSmall":"Yoos0","sizeSmallCenter":"PZYGL","flex":"_1dn7V","LEFT":"sA0OZ","CENTER":"WZHQF","RIGHT":"fV1-X","AUTO":"HGWaK","JUSTIFY":"_6RoEN"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-ebb89dc6.js.map
